const catalogs = {
  title: 'Catálogos',
  menu: 'Catálogos',
  newName: 'Nuevo valor',
  rename: 'Renombrar',
  created: 'Valor creado correctamente',
  renamed: 'Valor renombrado correctamente',
  merged: 'Valores fusionados correctamente',
  deleted: 'Valor eliminado correctamente',
  error: 'No se pudo completar la operación',
  empty: 'No hay valores en este catálogo',
  mergeConfirm:
    'Ya existe "%{target}". Se fusionará "%{source}" con "%{target}" y todos los contactos pasarán al valor existente. ¿Desea continuar?',
  deleteConfirm: '¿Desea eliminar "%{name}"?',
  deleteConfirmUsed:
    '"%{name}" está asignado a %{count} registro(s). Al eliminarlo se desasignará de todos ellos. ¿Desea continuar?',
  columns: {
    name: 'Nombre',
    usage: 'En uso',
  },
  types: {
    tags: 'Tags',
    interests: 'Intereses',
    'job-titles': 'Cargos',
    companies: 'Empresas',
    'contact-types': 'Tipos de contacto',
    'lead-sources': 'Procedencias',
    'hotel-categories': 'Tipologías',
    'pms-systems': 'PMS',
    'lock-systems': 'Cerraduras',
    'payment-processors': 'Procesadores de pago',
  },
};

export default catalogs;
